import { httpClient } from '@/network/clientController'

/** Get International Transfers Currencies List
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_internationalTransferscurrencies
*/
export const requestInternationalTransfersCurrenciesList = payload => {
	return httpClient({
		method: 'GET',
		url: 'internationalTransfers/currencies',
		params: { showOnlyEnabled: true },
		isCancellable: true
	})
}

/** Get International Transfers Requests List
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_internationalTransfers
*/
export const requestInternationalTransfersRequestsList = payload => {
	return httpClient({
		method: 'GET',
		url: 'internationalTransfers',
		params: payload,
		isCancellable: true
	})
}

/** Get International Transfers Status List
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_internationalTransfersstatus
*/
export const requestInternationalTransfersStatusList = payload => {
	return httpClient({
		method: 'GET',
		url: 'internationalTransfers/status',
		isCancellable: true
	})
}

/** Get International Transfers Estimated amount
@docs Não há documentação
@payload {Object}:
	value: amount,
	currencyOrigin: origin currency of transfer,
	currencyDestination: destination currency of transfer
*/
export const requestTMXEstimatedAmount = payload => {
	return httpClient({
		method: 'GET',
		url: '/internationalTransfers/exchange',
		params: payload,
		isCancellable: true
	})
}

/** Validate client for OPE execution
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_internationalTransfersvalidate
*/
export const validateClientForOPE = payload => {
	return httpClient({
		method: 'GET',
		url: '/internationalTransfers/validate',
		isCancellable: true
	})
}

/** Gets list of countries for ope adress country
@docs Não há documentação
*/
export const getCountriesList = payload => {
	return httpClient({
		method: 'GET',
		url: '/internationalTransfers/countries',
		params: payload,
		isCancellable: true
	})
}

/** Get lists of reasons for OPEs
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_internationalTransfersreasons
*/
export const getReasonsList = payload => {
	return httpClient({
		method: 'GET',
		url: '/internationalTransfers/reasons',
		params: payload,
		isCancellable: true
	})
}

/** Get lists of expenses for OPEs
@docs Não há documentação
*/
export const getExpensesList = payload => {
	return httpClient({
		method: 'GET',
		url: '/internationalTransfers/expenses',
		isCancellable: true
	})
}

/** Get Account Plafond for OPEs
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_internationalTransfersplafondaccount%7BaccountId%7D
*/
export const getAccountPlafond = payload => {
	return httpClient({
		method: 'GET',
		url: `/internationalTransfers/plafond/account/${payload.accountId}`,
		params: payload.isInstant ? { isInstant: payload.isInstant } : null,
		isCancellable: true
	})
}

/** Get Customer Limits for OPEs
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_internationalTransferscustomerlimits
*/
export const getCustomerLimits = payload => {
	return httpClient({
		method: 'GET',
		url: '/internationalTransfers/customerlimits',
		isCancellable: true
	})
}

/** Request Swift Details
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_internetinternationalTransfersswiftbic%7Bbic%7D
*/
export const requestSwiftDetails = (payload) => {
	return httpClient({
		method: 'GET',
		url: `/internationalTransfers/swift/bic/${payload.bic}`,
		isCancellable: true
	})
}

/** Get IBAN details
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_internationalTransfersibandetails
*/
export const getIBANDetails = payload => {
	return httpClient({
		method: 'GET',
		url: 'internationalTransfers/iban/details',
		params: payload,
		isCancellable: true
	})
}

/** Request Transfer Details
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_internationalTransfersdetail%7BtransferProcessId%7D
*/
export const requestTransferDetail = payload => {
	return httpClient({
		method: 'GET',
		url: `/internationalTransfers/detail/${payload}`,
		isCancellable: true
	})
}

/** Convert transfer amount
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_internationalTransfersexchange
*/
export const getConvertTransferAmount = payload => {
	return httpClient({
		method: 'GET',
		url: 'internationalTransfers/exchange',
		params: payload.params,
		isCancellable: true
	})
}

/** Creates OPE Transfer
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_internationalTransfers
*/
export const createPontualTransfer = (payload) => {
	return httpClient({
		method: 'POST',
		url: 'internationalTransfers',
		data: payload,
		operationTypeId: 36004 /* for mocks handling of tokens */
	})
}

/** Creates OPE Transfer
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_internationalTransfersinstant
*/
export const createInstantTransfer = (payload) => {
	return httpClient({
		method: 'POST',
		url: 'internationalTransfers/instant',
		data: payload,
		operationTypeId: 36017 /* for mocks handling of tokens */
	})
}

/** Get internacional banks
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_internationalTransfersbanks
*/
export const getInternationalBanks = payload => {
	return httpClient({
		method: 'GET',
		url: 'internationalTransfers/banks',
		isCancellable: true
	})
}

/** Get internacional corporate documents list
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_internetinternationalTransferscorporate
*/
export const getInternationalCorporateDocuments = payload => {
	return httpClient({
		method: 'GET',
		url: 'internationalTransfers/corporate',
		isCancellable: true
	})
}

/** Submit International Corporate Document
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_internetinternationalTransferscorporatesubmitDocument
*/
export const submitInternationalCorporateDocument = (payload) => {
	return httpClient({
		method: 'POST',
		url: 'internationalTransfers/corporate/submitDocument',
		data: payload.data,
        params: payload.params
	})
}

/** Submit International Corporate Transfer Process
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_internetinternationalTransferscorporateprocesssubmission
*/
export const submitInternationalCorporateTransferProcess = (payload) => {
	return httpClient({
		method: 'POST',
		url: 'internationalTransfers/corporate/process/submission',
		data: payload,
		operationTypeId: 4000005 /* for mocks handling of tokens */
	})
}

/** Get internacional corporate process list
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_internetinternationalTransferscorporateprocesses
*/
export const getInternationalCorporateProcesses = payload => {
	return httpClient({
		method: 'GET',
		url: 'internationalTransfers/corporate/processes',
		params: payload,
		isCancellable: true
	})
}

/** Get internacional corporate process detail
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_internetinternationalTransferscorporateprocesses%7Bid%7D
*/
export const getInternationalCorporateProcessDetail = payload => {
	return httpClient({
		method: 'GET',
		url: `internationalTransfers/corporate/processes/${payload}`,
		isCancellable: true
	})
}
